module.exports = __webpack_public_path__ + "img/DW365-073.7f7894d0.jpg";